import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  // Must stay at index 0: RouteConfigService.applyRoutes() replaces this route's `children`
  // array at runtime (router.resetConfig) by indexing router.config[0].
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [], // populated at runtime by RouteConfigService
  },
  // /login and /status live outside the LayoutComponent shell on purpose: they are not part
  // of the children array RouteConfigService rebuilds above, so they survive that reset.
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'status',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/status/status.component').then(m => m.StatusComponent),
  },
  { path: '**', redirectTo: '' },
];
